import React, { useState, useEffect } from "react";
import { Table, Empty, Col, Row, Popconfirm, Modal } from "antd";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import RequestHandler from "../../util/RequestHandler";
import SubscriberUserDelayedPaymentSendMailForm from "../Forms/SubscriberUserDelayedPaymentSendMailForm";
import { SendOutlined } from "@ant-design/icons";

const SubscriberFirmCollectionStatus = (props) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const isTabletOrMobileDevice = useMediaQuery({
    query: "(max-device-width: 1224px)",
  });
  const [firmMonthlyStatusReport, setFirmMonthlyStatusReport] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const [skip, setSkip] = useState(0);
  const [query, setQuery] = useState("");
  const [currencyString, setCurrencyString] = useState("");
  const [dataState, setDataState] = useState({ skip: 0, take: 20 });
  const [subscriberFirmId, setSubscriberFirmId] = useState(props.data.firmId);
  const [firmNameWithResponsibleUser, setFirmNameWithResponsibleUser] =
    useState(props.SubscriberFirmNameWithResponsibleUser);
  const [firmName, setFirmName] = useState(props.data.firmName);
  const [email, setEmail] = useState(props.data.mail);
  const [sendMailModal, setSendMailModal] = useState({
    visible: false,
    data: null,
  });

  useEffect(() => {
    setFirmMonthlyStatusReport({
      ...firmMonthlyStatusReport,
      loading: true,
    });

    RequestHandler.post(
      `/SubscriberFirm/GetMonthlyCollectionStatusPlanReports`,
      {
        firmId: subscriberFirmId,
      },
      false
    ).then((response) => {
      setCurrencyString("TRY");
      setFirmMonthlyStatusReport({
        data: response,
        total: response["@odata.count"],
        loading: false,
      });
    });
  }, [
    setDataState,
    skip,
    setSkip,
    query,
    setQuery,
    setSubscriberFirmId,
    setFirmNameWithResponsibleUser,
  ]);

  const onClickSendMail = (period, eMail, firmName, amount) => {
    setSendMailModal({
      visible: true,
      data: {
        period: period,
        eMail: eMail,
        firmName: firmName,
        amount: amount,
      },
    });
  };

  const columns = [
    {
      title: "",
      dataIndex: "",
      key: "FirmNameAndResponsibleUser",
      align: "center",
      width: "15%",
      render: () => {
        return (
          <p key={firmNameWithResponsibleUser} style={{ fontWeight: "700" }}>
            {firmNameWithResponsibleUser}
          </p>
        );
      },
    },
    {
      title: "Tarih",
      dataIndex: "transactionDate",
      key: "transactionDate",
      align: "center",
      width: "10%",
      style: "color:green",
      render: (text, record) => {
        return (
          <p style={{ fontWeight: "700" }}>
            {text == "9999/01"
              ? " Toplam "
              : moment(
                  text.split("/")[0] +
                    (text.split("/")[1].length > 1
                      ? text.split("/")[1]
                      : "0" + text.split("/")[1]) +
                    "13"
                ).format("MMM YYYY")}
          </p>
        );
      },
    },
    {
      title: "Tahsilat Planı",
      dataIndex: "collectPlanTotal",
      key: "collectPlanTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {",00"}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Gerçekleşen Tahsilat",
      dataIndex: "collectTotal",
      key: "collectTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {",00"}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Kalan Tahsilat",
      dataIndex: "collectMounthTotal",
      key: "collectMounthTotal",
      align: "center",
      width: "10%",
      render: (text, row, index) => {
        if (text === null || text.toString().includes("-") === true) {
          return "-";
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {",00"}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Mail Gönder",
      dataIndex: "",
      key: "sendMail",
      align: "center",
      width: "10%",
      render: (data, row) => {
        return parseFloat(data.collectMounthTotal) <= 0 ||
          data.transactionDate == "9999/01" ? (
          ""
        ) : (
          <Popconfirm
            title="Bu ay için gecikmiş ödeme maili göndermek istediğinize emin misiniz?"
            onConfirm={() => {
              onClickSendMail(
                data.transactionDate,
                email,
                firmName,
                data.collectMounthTotal
              );
            }}
            okText="Evet"
            cancelText="İptal"
          >
            <a>
              <SendOutlined style={{ fontSize: "130%" }} />
            </a>
          </Popconfirm>
        );
      },
    },
  ];

  return (
    <div>
      <Row>
        {isDesktopOrLaptop && (
          <>
            <Col span={2}></Col>
            <Col span={20}>
              <Table
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", maxHeight: "100%" }}
                size="small"
                rowKey="transactionDate"
                sortable={true}
                dataSource={firmMonthlyStatusReport.data}
                loading={firmMonthlyStatusReport.loading}
                pagination={false}
              />
            </Col>
            <Col span={2}></Col>
          </>
        )}
        {isTabletOrMobileDevice && (
          <>
            <Col span={24}>
              <Table
                columns={columns}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description="Veri Yok"
                    />
                  ),
                }}
                style={{ overflowX: "auto", maxHeight: "100%" }}
                size="small"
                rowKey="transactionDate"
                sortable={true}
                dataSource={firmMonthlyStatusReport.data}
                loading={firmMonthlyStatusReport.loading}
                pagination={false}
              />
            </Col>
          </>
        )}
      </Row>
      <Modal
        id="sendMail"
        centered
        visible={sendMailModal.visible}
        onCancel={() => setSendMailModal({ visible: false, data: null })}
        footer={null}
      >
        <SubscriberUserDelayedPaymentSendMailForm
          data={sendMailModal.data}
          onFinish={() => setSendMailModal({ visible: false, data: null })}
        />
      </Modal>
    </div>
  );
};

export default SubscriberFirmCollectionStatus;
